import RecommendedPortfolioItem from "./RecommendedPortfolioItem";
import styled from "styled-components";
import theme from "../../theme/theme";

const UL = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;

  li:not(:last-child) {
    border-bottom: 1px solid ${theme.colors.gray};
  }
`;

const RecommendedPortfolioList = ({ data }) => {
  return (
    <div>
      <UL>
        {data?.map((portfolio) => (
          <li key={portfolio.id}>
            <RecommendedPortfolioItem
              title={portfolio.name}
              modelAssetsDescription={portfolio?.modelAssetsDescription}
              percent={Number(portfolio.allocation * 100).toFixed(2)}
              pdfUrl={portfolio.pdfUrl}
            />
          </li>
        ))}
      </UL>
    </div>
  );
};

export default RecommendedPortfolioList;
